// extracted by mini-css-extract-plugin
module.exports = {"spoiler":"Spoiler_spoiler__VvVm6","fade_in":"Spoiler_fade_in__iUo_c"};